const handleSendMessage = (socket, {
  sessionId,
  fromUserId,
  fromRole,
  content,
  attachments = [],
  buttonText = '',
  buttonUrl = '',
}) => {
  console.log('📡 handleSendMessage socket:', socket);
console.log('📡 handleSendMessage ready state:', socket?.readyState);
console.log('📡 handleSendMessage sessionId:', sessionId);

  if (!socket || socket.readyState !== WebSocket.OPEN) {
    console.error("WebSocket not connected. Cannot send message.");
    return;
  }

  const payload = {
    sessionId,
    fromUserId,
    fromRole,
    content,
    dateTimeSent: new Date().toISOString(),
    attachments,
    buttonText,
    buttonUrl,
  };
  console.log('📡 Sending message payload:', payload);
  socket.send(JSON.stringify({
    type: "chat:message",
    payload,
  }));
  console.log('📡 Message sent successfully');
};

export default handleSendMessage;
